export class NotifMailParams {
  enabled: boolean;
  weekDays: number[];
  hours: number[];
  tags: string[];

  constructor(data?) {
    Object.assign(this, data);
  }
}
